import { AnimateHeight } from 'flos-react-cvi';
import React from 'react';
import { connect } from 'react-redux';
import { CoverageOption } from '../components/coverage-option';
import { selectCoverages, selectPrimaryType, selectResources, selectUpdatingCoverage } from '../store/selectors';
import { toggleCoverageSelection } from '../store/thunks';

const ContentsCoveragesView = ({
    isPrimary,
    requiredCoverages,
    optionalCoverages,
    showOptionalCoverages,
    resources,
    updatingCoverage,
    toggleCoverageSelectionProp
}) => {
    const mapCoverageOption = coverage => (
        <CoverageOption
            {...coverage}
            onToggle={toggleCoverageSelectionProp(coverage.objectCoverageId)}
            isPrimary={isPrimary}
            isLoading={coverage.objectCoverageId === updatingCoverage}
            disabled={updatingCoverage !== null}
            resources={resources}
            key={coverage.nameId}
        />
    );

    return (
        <>
            {requiredCoverages.map(mapCoverageOption)}
            <AnimateHeight height={showOptionalCoverages ? 'auto' : 0}>
                {optionalCoverages.map(mapCoverageOption)}
            </AnimateHeight>
        </>
    );
};

const mapStates = state => {
    const coverages = selectCoverages(state);
    const isPrimary = selectPrimaryType(state) === 'contents';
    const requiredCoverages = coverages.contents.filter(coverage => coverage.required);
    const optionalCoverages = coverages.contents.filter(coverage => !coverage.required);
    const showOptionalCoverages = isPrimary || requiredCoverages.some(coverage => coverage.chosen);

    return {
        isPrimary,
        requiredCoverages,
        optionalCoverages,
        showOptionalCoverages,
        resources: selectResources(state),
        updatingCoverage: selectUpdatingCoverage(state)
    };
};

const mapDispatch = dispatch => ({
    toggleCoverageSelectionProp: objectCoverageId => () => dispatch(toggleCoverageSelection(objectCoverageId))
});

export const ContentsCoverages = connect(mapStates, mapDispatch)(ContentsCoveragesView);
